// extracted by mini-css-extract-plugin
export default {"container":"Consent_container__8k8pL","consent":"Consent_consent__Ls4LH","close":"Consent_close__yqXXk"};